module.exports = __webpack_public_path__ + "img/t3-c15.9ce7e009.png";